import type React from "react";
import type { BriefDetails } from "src/model/model";
import AvatarAIDetails from "./AvatarAIDetails";
import AssetDetails from "./AssetDetails";
import ButtonDetails from "./ButtonDetails";
import GenericKeyValueDetails from "./GenericKeyValueDetails";
import HotspotDetails from "./HotspotDetails";
import QuizzDetails from "./QuizzDetails";
import SpeechToCheckDetails from "./SpeechToCheckDetails";
import TextDetails from "./TextDetails";
import ZoneDetectDetails from "./ZoneDetectDetails";

export interface InteractionDetailsProps {
  type: string;
  mode: "plan" | "recap";
  data: BriefDetails | Record<string, unknown>;
}

type RendererComponent = React.FC<{
  data: BriefDetails | Record<string, unknown>;
  mode: "plan" | "recap";
}>;

const RENDERER_REGISTRY: Record<string, RendererComponent> = {
  Text: TextDetails,
  "Quizz Text": QuizzDetails,
  "Yes/No Question": QuizzDetails,
  "Random Quizz": QuizzDetails,
  "Quizz Sort": QuizzDetails,
  Button: ButtonDetails,
  "Countdown Button": ButtonDetails,
  "Reload Button": ButtonDetails,
  AvatarAIPersona: AvatarAIDetails,
  AvatarAISessionDebrief: AvatarAIDetails,
  "Hotspot image": HotspotDetails,
  "Hotspot vidéo": HotspotDetails,
  "Zone Detect": ZoneDetectDetails,
  "Speech to Check": SpeechToCheckDetails,
  PDF: AssetDetails,
  "Video 2D": AssetDetails,
  Audio: AssetDetails,
  Tuto: AssetDetails,
  Tuto2: AssetDetails,
};

const InteractionDetails: React.FC<InteractionDetailsProps> = ({ type, mode, data }) => {
  if (!data || typeof data !== "object") return null;

  const Renderer = RENDERER_REGISTRY[type] || GenericKeyValueDetails;
  return <Renderer data={data} mode={mode} />;
};

export default InteractionDetails;
